<template>
  <div class="mit-my-borrowed-list pa-5">
    <BaseMitLoading :show="loading" :fullscreen="false"/>
    <v-card flat>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on }">
          <v-btn small v-on="on" class="ma-2" @click="resetDialog">Add Filter</v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Add Filter</span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12>
                  <v-select :items="filterableHeaders" :hint="filterItem.hint" :persistent-hint="true" item-text="text" item-value="value" label="Name" required v-model="filterItem" return-object @change="changedFilter"></v-select>
                  <v-text-field label="Value" required v-model="filterValue"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
            <v-btn color="blue darken-1" text @click="addFilter">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
        <BaseMitUrlParams ref="mitUrlParamsRef" v-on:changed="updateFilters"/>
    </v-card>
    <BaseMitDataTable
      title="Activity"
      :page="paging.page"
      :pageSize="paging.pageSize"
      :totalItems="paging.totalItems"
      :pageSizes="{itemsPerPageOptions:[10, 20, 50, 100]}"
      :editable="false"
      :headers="headers"
      :items="activity"
      @pagination="updatePagination"
    >
      <template v-slot:item.data_ui="{ item, search }">
        <v-tooltip top max-width="600" color="#333" offset-overflow style="opacity: 1!important;">
          <template v-slot:activator="{ on }">
            <v-icon :color="(search.text.length > 0 && item.data_ui.indexOf(search.text) > -1 )?'primary':''" :class="" v-on="on">mdi-text-box-outline</v-icon>
          </template>
          <div style="word-break: break-word;"><b>Token:</b> {{item.data.token}}</div>
          <div style="word-break: break-word;"><b>Generated By:</b> {{item.data.generatedBy}}</div>
          <div style="word-break: break-word;"><b>Generated ID:</b> {{item.data.generatedId}}</div>
          <div style="word-break: break-word;"><b># Reset Attempts:</b> {{item.data.numberOfResetTries}}</div>
          <div style="word-break: break-word;"><b>Message:</b> {{item.data.message}}</div>
          <div style="word-break: break-word;"><b>Error:</b> {{item.data.error}}</div>
          <div style="word-break: break-word;"><b>Expire Time:</b> {{item.data.expire_time}}</div>

        </v-tooltip>
      </template>
    </BaseMitDataTable>
  </div>
</template>

<script>
import moment from 'moment';
import MitPasswordActivityService from '../../services/MitPasswordActivityService.js';
import BaseMitDataTable from '../../../base/components/BaseMitDataTable.vue';
import BaseMitUrlParams from '../../../base/components/BaseMitUrlParams.vue';
import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';

export default {
  name: 'MitPasswordActivityList',
  components: {
    BaseMitLoading,
    BaseMitDataTable,
    BaseMitUrlParams
  },
  props: {
  },
  data: function() {
    return {
      dialog:false,
      filterItem:null,
      filterValue:'',
      loading:false,
      search: '',
      options:{},
      paging:{
        page:1,
        pageSize:5,
        totalItems:0
      },
      filterableHeaders:[ //moment().local().format("hh:mm A")
        {text: 'CSAIL ID',value: 'csailId', default:'', hint:'The exact csail id'},
        {text: 'Email',value: 'csailEmail', default:'', hint:'The exact email'},
        {text: 'Type',value: 'type', default:'', hint:'The exact type "reset" or "change"'},
        {text: 'IP',value: 'ip', default:'', hint:'The exact ip address'},
        {text: 'Start Date',value: 'startDt', default:MitPasswordActivityService.getActivityDateStringLocal(), hint:'Create Date >=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
        {text: 'End Date',value: 'endDt', default:MitPasswordActivityService.getActivityDateStringLocal(), hint:'Create Date <=. Format is "YYYY-MM-DD HH:mm:ss" 24h local time.'},
      ],
      headers:[
          {text: 'CSAIL ID',sortable: true,value: 'csailId'},
          {text: 'Email',sortable: true,value: 'csailEmail'},
          {text: 'Type',sortable: true,value: 'type'},
          {text: 'IP',sortable: true,value: 'ip'},
          {text: 'Data',sortable: false,value: 'data_ui'},
          {text: 'Successful',sortable: true,value: 'successful'},
          {text: 'Create Date',sortable: true,value: 'dates_local.createDt'},
          {text: 'Finish Date',sortable: true,value: 'dates_local.finishDt'}
        ],
      activity:[]
    }
  },
  created() {
    this.resetDialog();
  },
  methods : {
    updatePagination (pagination) {
      //setting this into the control will trigger this event so initiall don't bother refreshing
      //if the items length is zero, we have no data yet.
      if(pagination.itemsLength > 0){
        this.paging.page = pagination.page;
        this.paging.pageSize = pagination.itemsPerPage;

        this.refreshData(this.paging, this.options);
      }

    },
    updateFilters(options){
      this.options = options;
      this.paging.page = 1;//we changed the filter so start over with a new data set
      this.refreshData(this.paging, this.options);
    },
    refreshData(pagination, options){
      this.loading = true;
      MitPasswordActivityService.requestGetActivity(pagination, options)
        .then((data) => {
          this.loading = false;

          this.activity = data.logs;
          this.paging.totalItems = data.total;
        })
        .catch((error) => {
          this.loading = false;
          console.log('An error occurred trying to get keys list', error);
        });
    },
    resetDialog(){
      this.filterItem = this.filterableHeaders[0];
      this.filterValue = null;
    },
    changedFilter(item){
      this.filterValue = item.default;
    },
    addFilter(){
      if(MitPasswordActivityService.isActivityDateTimeValid(this.filterValue)){
        this.filterValue = MitPasswordActivityService.getActivityDateStringUtc(this.filterValue);
      }

      this.$refs.mitUrlParamsRef.add(this.filterItem.value, this.filterValue);
      this.dialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
